import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import "../intl.js";
import { eventKey as t } from "../core/events.js";
import s from "../core/Handles.js";
import { escapeRegExpString as i } from "../core/string.js";
import { watch as r, on as n, init as o } from "../core/watchUtils.js";
import { aliasOf as a } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { property as u } from "../core/accessorSupport/decorators/property.js";
import { subclass as l } from "../core/accessorSupport/decorators/subclass.js";
import c from "./Widget.js";
import d from "./Search/SearchResultRenderer.js";
import h from "./Search/SearchViewModel.js";
import { storeNode as g, keepMenuItemWithinView as p, isActivationKey as _ } from "./support/widgetUtils.js";
import { messageBundle as m } from "./support/decorators/messageBundle.js";
import "../core/Logger.js";
import { vmEvent as v } from "./support/decorators/vmEvent.js";
import { tsx as M } from "./support/jsxFactory.js";
import { substitute as I } from "../intl/substitute.js";
var w = {
  base: "esri-search esri-widget",
  loader: "esri-widget__loader",
  loaderText: "esri-widget__loader-text",
  loaderAnimation: "esri-widget__loader-animation",
  esriInput: "esri-input",
  hasMultipleSources: "esri-search--multiple-sources",
  isLoading: "esri-search--loading",
  isSearching: "esri-search--searching",
  showSuggestions: "esri-search--show-suggestions",
  showSources: "esri-search--sources",
  showWarning: "esri-search--warning",
  container: "esri-search__container",
  input: "esri-search__input",
  inputContainer: "esri-search__input-container",
  form: "esri-search__form",
  submitButton: "esri-search__submit-button",
  sourcesButton: "esri-search__sources-button",
  clearButton: "esri-search__clear-button",
  sourceName: "esri-search__source-name",
  suggestionsMenu: "esri-search__suggestions-menu",
  suggestionList: "esri-search__suggestions-list",
  suggestionListCurrentLocation: "esri-search__suggestions-list--current-location",
  sourcesMenu: "esri-search__sources-menu",
  source: "esri-search__source",
  warningMenu: "esri-search__warning-menu",
  warningMenuBody: "esri-search__warning-body",
  warningMenuHeader: "esri-search__warning-header",
  warningMenuText: "esri-search__warning-text",
  noValueText: "esri-search__no-value-text",
  esriWidgetDisabled: "esri-widget--disabled",
  button: "esri-widget--button",
  fallbackText: "esri-icon-font-fallback-text",
  header: "esri-widget__heading",
  locate: "esri-icon-locate-circled",
  menu: "esri-menu",
  menuList: "esri-menu__list",
  menuItem: "esri-menu__list-item",
  menuItemActive: "esri-menu__list-item--active",
  menuItemFocus: "esri-menu__list-item--focus",
  menuHeader: "esri-menu__header",
  loadingIcon: "esri-icon-loading-indicator esri-rotating",
  searchIcon: "esri-icon-search",
  dropdownIcon: "esri-icon-down-arrow esri-search__sources-button--down",
  dropupIcon: "esri-icon-up-arrow esri-search__sources-button--up",
  clearIcon: "esri-icon-close",
  noticeIcon: "esri-icon-notice-triangle",
  widgetIcon: "esri-icon-search",
  disabled: "esri-disabled"
},
    S = /<[a-z/][\s\S]*>/i;

var b = /*#__PURE__*/function (_c) {
  _inherits(b, _c);

  var _super = _createSuper(b);

  function b(e, t) {
    var _this;

    _classCallCheck(this, b);

    _this = _super.call(this, e, t), _this._activeMenuItemIndex = -1, _this._handles = new s(), _this._inputNode = null, _this._menuItemCount = 0, _this._sourceMenuButtonNode = null, _this._sourceListNode = null, _this._suggestionListNode = null, _this._searchResultRenderer = new d(), _this._locateFailed = null, _this._container = null, _this.activeMenu = "none", _this.activeSource = null, _this.activeSourceIndex = null, _this.allPlaceholder = null, _this.allSources = null, _this.autoNavigate = null, _this.autoSelect = null, _this.defaultSources = null, _this.disabled = !1, _this.goToOverride = null, _this.iconClass = w.widgetIcon, _this.includeDefaultSources = null, _this.label = void 0, _this.locationEnabled = null, _this.maxResults = null, _this.maxSuggestions = null, _this.messages = null, _this.messagesCommon = null, _this.minSuggestCharacters = null, _this.popupEnabled = null, _this.popupTemplate = null, _this.portal = null, _this.resultGraphic = null, _this.resultGraphicEnabled = null, _this.results = null, _this.searchAllEnabled = null, _this.searchTerm = null, _this.selectedResult = null, _this.sources = null, _this.suggestions = null, _this.suggestionsEnabled = null, _this.view = null, _this.viewModel = new h(), _this._clearActiveMenu = function () {
      _this.activeMenu = "none";
    }, _this._removeActiveMenu = function (e) {
      var t;
      var s = e.relatedTarget;
      s && null != (t = _this._container) && t.contains(s) || _this._clearActiveMenu();
    }, _this.own(r(_assertThisInitialized(_this), "searchTerm", function (e) {
      (e && "warning" === _this.activeMenu || !e && !_this.get("viewModel.selectedSuggestion.location")) && _this._clearActiveMenu();
    }), n(_assertThisInitialized(_this), "viewModel.allSources", "change", function () {
      return _this._watchSourceChanges();
    }), o(_assertThisInitialized(_this), "activeMenu", function () {
      return _this._resetActiveMenuItemIndex();
    }), o(_assertThisInitialized(_this), "viewModel.defaultPopupTemplate", function (e) {
      e && (e.content = _this._renderSearchResultsContent.bind(_assertThisInitialized(_this)));
    }));
    return _this;
  }

  _createClass(b, [{
    key: "destroy",
    value: function destroy() {
      this._handles.destroy(), this._handles = null, this._cancelSuggest(), this._cancelSearch(), this._searchResultRenderer && (this._searchResultRenderer.viewModel = null, this._searchResultRenderer.destroy(), this._searchResultRenderer = null);
    }
  }, {
    key: "displayedSearchTerm",
    get: function get() {
      return "".concat(this.viewModel.searchTerm).trim();
    }
  }, {
    key: "inputId",
    get: function get() {
      return this._buildId("input");
    }
  }, {
    key: "suggestionsMenuId",
    get: function get() {
      return this._buildId("suggest-menu");
    }
  }, {
    key: "sourceMenuId",
    get: function get() {
      return this._buildId("source-menu");
    }
  }, {
    key: "sourceMenuButtonId",
    get: function get() {
      return this._buildId("source-menu-button");
    }
  }, {
    key: "clear",
    value: function clear() {}
  }, {
    key: "focus",
    value: function focus() {
      var e;
      null == (e = this._inputNode) || e.focus(), this.emit("search-focus");
    }
  }, {
    key: "blur",
    value: function blur() {
      var e;
      null == (e = this._inputNode) || e.blur(), this.emit("search-blur");
    }
  }, {
    key: "search",
    value: function search(e) {
      var _this2 = this;

      this._clearActiveMenu(), this._cancelSuggest(), this._cancelSearch();
      var t = new AbortController(),
          s = t.signal;
      return this._searchController = t, this.viewModel.search(e, {
        signal: s
      }).catch(function (e) {
        if (_this2._searchController === t) return _this2._clearActiveMenu(), _this2._searchController = null, e;
      }).then(function (e) {
        if (_this2._searchController === t) return _this2.activeMenu = e.numResults ? "none" : "warning", _this2._searchController = null, e;
      });
    }
  }, {
    key: "suggest",
    value: function suggest(e) {
      var _this3 = this;

      this._cancelSuggest();

      var t = new AbortController(),
          s = t.signal;
      return this._suggestController = t, this.viewModel.suggest(e, null, {
        signal: s
      }).then(function (e) {
        if (_this3._suggestController === t) return _this3._suggestController = null, e.numResults && _this3._openSuggestionMenu(), _this3._scrollToTopSuggestion(), e;
      }).catch(function () {
        if (_this3._suggestController === t) return _this3._suggestController = null, null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _t;

      var e = this.viewModel.state,
          t = (_t = {}, _defineProperty(_t, w.disabled, "disabled" === e), _defineProperty(_t, w.esriWidgetDisabled, this.disabled), _t);
      return M("div", {
        class: this.classes(w.base, t)
      }, "loading" === e ? this.renderLoader() : this.renderContainer());
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton() {
      var e = this.messages;
      return M("button", {
        "aria-label": e.searchButtonTitle,
        bind: this,
        class: this.classes(w.submitButton, w.button),
        key: "esri-search__submit-button",
        onclick: this._handleSearchButtonClick,
        title: e.searchButtonTitle
      }, M("span", {
        "aria-hidden": "true",
        class: w.searchIcon
      }));
    }
  }, {
    key: "renderWarningMenu",
    value: function renderWarningMenu() {
      return M("div", {
        key: "esri-search__error-menu",
        class: this.classes(w.menu, w.warningMenu)
      }, M("div", {
        class: w.warningMenuBody
      }, this.renderWarning()));
    }
  }, {
    key: "renderSourceMenuButton",
    value: function renderSourceMenuButton() {
      var e = this.messages,
          t = this.activeMenu,
          s = this.sourceMenuId,
          i = this.sourceMenuButtonId,
          _this$viewModel = this.viewModel,
          r = _this$viewModel.activeSourceIndex,
          n = _this$viewModel.allSources;
      return n.length > 1 ? M("button", {
        id: i,
        key: "esri-search__source-menu-button",
        bind: this,
        "aria-label": e.searchIn,
        title: e.searchIn,
        "aria-haspopup": "true",
        "aria-expanded": ("source" === t).toString(),
        "aria-controls": s,
        class: this.classes(w.sourcesButton, w.button),
        onclick: this._handleSourcesMenuToggleClick,
        onfocus: this._clearActiveMenu,
        afterCreate: g,
        "data-node-ref": "_sourceMenuButtonNode"
      }, M("span", {
        "aria-hidden": "true",
        class: w.dropdownIcon
      }), M("span", {
        "aria-hidden": "true",
        class: w.dropupIcon
      }), M("span", {
        class: w.sourceName
      }, this._getSourceName(r))) : null;
    }
  }, {
    key: "renderSourcesList",
    value: function renderSourcesList() {
      var _this4 = this;

      var _this$viewModel2 = this.viewModel,
          e = _this$viewModel2.allSources,
          t = _this$viewModel2.searchAllEnabled,
          s = this._activeMenuItemIndex,
          i = this.activeMenu,
          r = this.sourceMenuId,
          n = this.sourceMenuButtonId,
          o = "source" === i && s > -1 ? this._buildId("source-item", s) : null;
      return e.length > 1 ? M("ul", {
        "aria-activedescendant": o,
        "aria-labelledby": n,
        id: r,
        role: "menu",
        bind: this,
        afterCreate: g,
        onkeydown: this._handleSourceMenuKeydown,
        onkeyup: this._handleSourceMenuKeyup,
        "data-node-ref": "_sourceListNode",
        class: w.menuList,
        tabIndex: -1
      }, t ? this.renderSource(h.ALL_INDEX) : null, e.map(function (e, t) {
        return _this4.renderSource(t);
      }).toArray()) : null;
    }
  }, {
    key: "renderSourcesMenu",
    value: function renderSourcesMenu() {
      var e = this.viewModel.allSources;
      return e.length > 1 ? M("div", {
        key: "esri-search__source-menu",
        class: this.classes(w.menu, w.sourcesMenu)
      }, this.renderSourcesList()) : null;
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      var e = this.messages,
          t = this.messagesCommon;
      return M("div", {
        class: w.loader,
        key: "base-loader"
      }, M("span", {
        "aria-hidden": "true",
        class: w.loaderAnimation
      }), M("span", {
        class: w.fallbackText
      }, e.searchButtonTitle), M("span", {
        class: w.loaderText
      }, t.loading));
    }
  }, {
    key: "renderContainer",
    value: function renderContainer() {
      var _i,
          _this5 = this;

      var _this$viewModel3 = this.viewModel,
          e = _this$viewModel3.allSources,
          t = _this$viewModel3.state,
          s = this.activeMenu,
          i = (_i = {}, _defineProperty(_i, w.hasMultipleSources, e.length > 1), _defineProperty(_i, w.isLoading, "loading" === t), _defineProperty(_i, w.isSearching, "searching" === t), _defineProperty(_i, w.showWarning, "warning" === s), _defineProperty(_i, w.showSources, "source" === s), _defineProperty(_i, w.showSuggestions, "suggestion" === s), _i);
      return M("div", {
        tabIndex: -1,
        afterCreate: function afterCreate(e) {
          _this5._container = e, e.addEventListener("focusout", _this5._removeActiveMenu);
        },
        afterRemoved: function afterRemoved(e) {
          e.removeEventListener("focusout", _this5._removeActiveMenu);
        },
        class: this.classes(i, w.container),
        key: "base-container"
      }, this.renderSourceMenuButton(), this.renderSourcesMenu(), this.renderInputContainer(), this.renderSubmitButton(), this.renderWarningMenu());
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      return this.searchTerm ? M("button", {
        bind: this,
        class: this.classes(w.clearButton, w.button),
        key: "esri-search__clear-button",
        onclick: this._handleClearButtonClick,
        onfocus: this._clearActiveMenu,
        title: this.messages.clearButtonTitle
      }, M("span", {
        "aria-hidden": "true",
        class: w.clearIcon
      })) : null;
    }
  }, {
    key: "renderLocationGroup",
    value: function renderLocationGroup() {
      var e = this.messages,
          t = this.locationEnabled,
          s = this.displayedSearchTerm,
          i = t && !s,
          r = "suggestion" === this.activeMenu && 0 === this._activeMenuItemIndex;
      return i ? M("ul", {
        role: "group",
        key: "esri-search__suggestion-list-current-location",
        class: this.classes(w.menuList, w.suggestionList, w.suggestionListCurrentLocation)
      }, M("li", {
        bind: this,
        "data-current-location-item": !0,
        onclick: this._handleUseCurrentLocationClick,
        id: this._buildId("suggestion-item", 0),
        "aria-selected": ("suggestion" === this.activeMenu && 0 === this._activeMenuItemIndex).toString(),
        role: "option",
        class: this.classes(w.menuItem, r ? w.menuItemFocus : null)
      }, M("span", {
        "aria-hidden": "true",
        class: w.locate
      }), " ", e.useCurrentLocation)) : null;
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var e = this.activeMenu,
          t = this.locationEnabled,
          s = this.displayedSearchTerm,
          i = this.messages,
          r = this.suggestionsMenuId,
          n = this.inputId,
          o = this._activeMenuItemIndex,
          _this$viewModel4 = this.viewModel,
          a = _this$viewModel4.maxInputLength,
          u = _this$viewModel4.placeholder,
          l = _this$viewModel4.searchTerm,
          c = _this$viewModel4.suggestionCount,
          d = !(!(t && !s) && !c),
          h = "suggestion" === e && o > -1 ? this._buildId("suggestion-item", o) : null;
      return M("input", {
        "aria-activedescendant": h,
        "aria-autocomplete": "list",
        "aria-expanded": (d && "suggestion" === e).toString(),
        "aria-controls": d ? r : null,
        "aria-haspopup": "listbox",
        "aria-label": i.searchButtonTitle,
        bind: this,
        placeholder: u,
        maxlength: a,
        autocomplete: "off",
        type: "text",
        class: this.classes(w.esriInput, w.input),
        value: l,
        id: n,
        role: "combobox",
        onkeyup: this._handleInputKeyup,
        onclick: this._openSuggestionMenu,
        oninput: this._handleInputPaste,
        onpaste: this._handleInputPaste,
        afterCreate: g,
        "data-node-ref": "_inputNode",
        onfocus: this.focus,
        onblur: this.blur,
        title: l ? "" : u
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return M("form", {
        key: "esri-search__form",
        bind: this,
        class: w.form,
        onsubmit: this._formSubmit,
        role: "search"
      }, this.renderInput());
    }
  }, {
    key: "renderSuggestList",
    value: function renderSuggestList(e) {
      var _this6 = this;

      var t = e.sourceIndex,
          s = e.results.length,
          i = e.results;
      return s ? M("ul", {
        role: "group",
        key: "esri-search__suggestion-list-".concat(t),
        class: this.classes(w.menuList, w.suggestionList)
      }, i.map(function (e) {
        return _this6.renderSuggestion(e, _this6._menuItemCount++);
      })) : null;
    }
  }, {
    key: "renderSuggestionsGroup",
    value: function renderSuggestionsGroup() {
      var _this7 = this;

      var e = this.viewModel.suggestions;
      return e ? e.map(function (e) {
        return [_this7.renderSuggestionHeader(e), _this7.renderSuggestList(e)];
      }) : null;
    }
  }, {
    key: "renderSuggestionsMenu",
    value: function renderSuggestionsMenu() {
      var e = this.displayedSearchTerm,
          t = this.locationEnabled,
          s = this.suggestionsMenuId,
          i = this.inputId,
          r = this.viewModel.suggestionCount,
          n = t && !e || r;
      return this._menuItemCount = 0, n ? M("div", {
        id: s,
        key: "esri-search__suggestions-menu",
        class: this.classes(w.menu, w.suggestionsMenu),
        role: "listbox",
        "aria-labelledby": i,
        bind: this,
        afterCreate: g,
        "data-node-ref": "_suggestionListNode"
      }, this.renderLocationGroup(), this.renderSuggestionsGroup()) : null;
    }
  }, {
    key: "renderInputContainer",
    value: function renderInputContainer() {
      return M("div", {
        key: "esri-search__input-container",
        class: w.inputContainer
      }, this.renderForm(), this.renderSuggestionsMenu(), this.renderClearButton());
    }
  }, {
    key: "renderSuggestionHeader",
    value: function renderSuggestionHeader(e) {
      var _this$viewModel5 = this.viewModel,
          t = _this$viewModel5.allSources,
          s = _this$viewModel5.activeSourceIndex,
          i = e.sourceIndex,
          r = e.results.length,
          n = t.length > 1 && s === h.ALL_INDEX;
      return r && n ? M("div", {
        key: "esri-search__suggestion-header-".concat(i),
        class: w.menuHeader
      }, this._getSourceName(i)) : null;
    }
  }, {
    key: "renderSuggestion",
    value: function renderSuggestion(e, t) {
      var s = this._activeMenuItemIndex,
          i = this.messages,
          r = this.viewModel.searchTerm;

      if (r) {
        var _n = e.text,
            _o = _n || i.untitledResult,
            _a = S.test(_o),
            _u = [];

        if (_a) _u.push(M("div", {
          innerHTML: _o
        }));else {
          var _e = this._splitResult(_o, r),
              _t2 = r.toLowerCase();

          _e.forEach(function (e, s) {
            e && e.length && (e.toLowerCase() === _t2 ? _u.push(M("strong", {
              key: s
            }, e)) : _u.push(e));
          });
        }

        var _l = "suggestion" === this.activeMenu && s === t;

        return M("li", {
          bind: this,
          id: this._buildId("suggestion-item", t),
          "aria-selected": ("suggestion" === this.activeMenu && this._activeMenuItemIndex === t).toString(),
          onclick: this._handleSuggestionClick,
          key: "esri-search__suggestion_".concat(t),
          "data-suggestion": e,
          role: "option",
          class: this.classes(w.menuItem, _l ? w.menuItemFocus : null)
        }, _u);
      }
    }
  }, {
    key: "renderSource",
    value: function renderSource(e) {
      var _i2;

      var _this$viewModel6 = this.viewModel,
          t = _this$viewModel6.activeSourceIndex,
          s = _this$viewModel6.searchAllEnabled,
          i = (_i2 = {}, _defineProperty(_i2, w.menuItemActive, e === t), _defineProperty(_i2, w.menuItemFocus, "source" === this.activeMenu && e === (s ? this._activeMenuItemIndex - 1 : this._activeMenuItemIndex)), _i2),
          r = s ? e + 1 : e;
      return M("li", {
        bind: this,
        key: "esri-search__source-".concat(e),
        id: this._buildId("source-item", r),
        "aria-checked": (e === t).toString(),
        onclick: this._handleSourceClick,
        "data-source-index": e,
        role: "menuitemradio",
        class: this.classes(w.source, w.menuItem, i)
      }, this._getSourceName(e));
    }
  }, {
    key: "renderNoResultsWarning",
    value: function renderNoResultsWarning(e) {
      var t = this.messages,
          s = e ? I(t.noResultsFoundForValue, {
        value: "\"".concat(e, "\"")
      }) : t.noResultsFound;
      return M("div", {
        key: "esri-search__no_results"
      }, M("div", {
        class: w.warningMenuHeader
      }, t.noResults), M("div", {
        class: w.warningMenuText
      }, s));
    }
  }, {
    key: "renderEmptySearchWarning",
    value: function renderEmptySearchWarning() {
      var e = this.messages;
      return M("div", {
        key: "esri-search__empty-search"
      }, M("span", {
        "aria-hidden": "true",
        class: w.noticeIcon
      }), M("span", {
        class: w.noValueText
      }, e.emptyValue));
    }
  }, {
    key: "renderLocateWarning",
    value: function renderLocateWarning() {
      var e = this.messages;
      return M("div", {
        key: "esri-search__locate-error"
      }, M("span", {
        "aria-hidden": "true",
        class: w.noticeIcon
      }), M("span", {
        class: w.noValueText
      }, e.locateError));
    }
  }, {
    key: "renderWarning",
    value: function renderWarning() {
      var e;
      var t = this.displayedSearchTerm,
          s = this._locateFailed,
          i = this.viewModel;
      return s ? this.renderLocateWarning() : null != (e = i.selectedSuggestion) && e.location || t ? this.renderNoResultsWarning(t) : this.renderEmptySearchWarning();
    }
  }, {
    key: "_resetActiveMenuItemIndex",
    value: function _resetActiveMenuItemIndex() {
      this._activeMenuItemIndex = -1;
    }
  }, {
    key: "_buildId",
    value: function _buildId(e, t) {
      return "".concat(this.id, "-").concat(e).concat(void 0 === t ? "" : "-".concat(t));
    }
  }, {
    key: "_watchSourceChanges",
    value: function _watchSourceChanges() {
      var _this8 = this;

      var e = this._handles,
          t = this.viewModel.allSources,
          s = "sources";
      e.remove(s), t.forEach(function (t) {
        return e.add(r(t, "name", function () {
          return _this8.scheduleRender();
        }), s);
      });
    }
  }, {
    key: "_handleSourcesMenuToggleClick",
    value: function _handleSourcesMenuToggleClick() {
      var e = "source" === this.activeMenu;
      var t;
      (this.activeMenu = e ? "none" : "source", this.renderNow(), "source" === this.activeMenu) && (null == (t = this._sourceListNode) || t.focus());
    }
  }, {
    key: "_handleClearButtonClick",
    value: function _handleClearButtonClick() {
      this.viewModel.clear(), this._focus();
    }
  }, {
    key: "_handleSearchButtonClick",
    value: function _handleSearchButtonClick() {
      this.search();
    }
  }, {
    key: "_handleSuggestionClick",
    value: function _handleSuggestionClick(e) {
      var t = e.currentTarget["data-suggestion"];
      t && (this._focus(), this.search(t));
    }
  }, {
    key: "_handleUseCurrentLocationClick",
    value: function _handleUseCurrentLocationClick() {
      this._useCurrentLocation();
    }
  }, {
    key: "_useCurrentLocation",
    value: function _useCurrentLocation() {
      var _this9 = this;

      this._focus("none"), this._cancelSuggest(), this._cancelSearch();
      var e = new AbortController(),
          t = e.signal;
      this._searchController = e, this.viewModel.searchNearby({
        signal: t
      }).catch(function () {
        _this9._locateFailed = !0, _this9.activeMenu = "warning";
      }).then(function () {
        _this9._searchController = null;
      });
    }
  }, {
    key: "_handleSourceClick",
    value: function _handleSourceClick(e) {
      this._setSourceFromMenuItem(e.currentTarget);
    }
  }, {
    key: "_setSourceFromMenuItem",
    value: function _setSourceFromMenuItem(e) {
      var t;
      if (!e) return;
      var s = e["data-source-index"];
      this.viewModel.activeSourceIndex = s, this._clearActiveMenu(), null == (t = this._sourceMenuButtonNode) || t.focus();
    }
  }, {
    key: "_cancelSuggest",
    value: function _cancelSuggest() {
      this._suggestController && (this._suggestController.abort(), this._suggestController = null);
    }
  }, {
    key: "_cancelSearch",
    value: function _cancelSearch() {
      this._searchController && (this._searchController.abort(), this._searchController = null), this._locateFailed = !1;
    }
  }, {
    key: "_handleInputKeyup",
    value: function _handleInputKeyup(e) {
      var s;
      var i = t(e);
      if (e.ctrlKey || e.metaKey || "Copy" === i || "ArrowLeft" === i || "ArrowRight" === i || "Shift" === i) return;
      if ("Tab" === i || "Escape" === i || e.shiftKey && "Tab" === i) return this._cancelSuggest(), void ("Escape" === i && this._clearActiveMenu());
      var r = "Home" === i || "End" === i || "ArrowUp" === i || "ArrowDown" === i;
      if ("Enter" === i && this._activeMenuItemIndex < 0) return void this._cancelSuggest();
      var n = null == (s = this._suggestionListNode) ? void 0 : s.getElementsByTagName("li");

      if (null != n && n.length) {
        if ("suggestion" !== this.activeMenu && this._openSuggestionMenu(), r) return e.preventDefault(), this._cancelSuggest(), void this.handleItemNavigation(i, n, this._suggestionListNode);
        var _t3 = n[this._activeMenuItemIndex];

        if ("Enter" === i && _t3) {
          var _e2 = _t3["data-suggestion"];
          return void (_e2 ? (this._focus(), this.search(_e2)) : _t3["data-current-location-item"] && this._useCurrentLocation());
        }
      }

      this.viewModel.searchTerm && this.suggest();
    }
  }, {
    key: "handleItemNavigation",
    value: function handleItemNavigation(e, t, s) {
      var i = this._activeMenuItemIndex;
      "Home" === e && (this._activeMenuItemIndex = 0), "End" === e && (this._activeMenuItemIndex = t.length - 1), "ArrowUp" === e && (this._activeMenuItemIndex = this._activeMenuItemIndex <= 0 ? t.length - 1 : this._activeMenuItemIndex - 1), "ArrowDown" === e && (this._activeMenuItemIndex = this._activeMenuItemIndex === t.length - 1 ? 0 : this._activeMenuItemIndex + 1), i !== this._activeMenuItemIndex && p(t[this._activeMenuItemIndex], s);
    }
  }, {
    key: "_scrollToTopSuggestion",
    value: function _scrollToTopSuggestion() {
      this._suggestionListNode && (this._suggestionListNode.scrollTop = 0);
    }
  }, {
    key: "_openSuggestionMenu",
    value: function _openSuggestionMenu() {
      this.activeMenu = "suggestion";
    }
  }, {
    key: "_handleInputPaste",
    value: function _handleInputPaste(e) {
      var t = e.target;
      this.viewModel.searchTerm !== t.value && (this.viewModel.searchTerm = t.value), this.viewModel.searchTerm && this.suggest();
    }
  }, {
    key: "_handleSourceMenuKeydown",
    value: function _handleSourceMenuKeydown(e) {
      var s = t(e);

      if (_(s)) {
        e.preventDefault();

        var _t4 = this._sourceListNode.getElementsByTagName("li")[this._activeMenuItemIndex];

        this._setSourceFromMenuItem(_t4);
      } else "ArrowUp" !== s && "ArrowDown" !== s && "End" !== s && "Home" !== s || e.preventDefault();
    }
  }, {
    key: "_handleSourceMenuKeyup",
    value: function _handleSourceMenuKeyup(e) {
      var s;
      var i = t(e),
          r = "ArrowUp" === i || "ArrowDown" === i || "End" === i || "Home" === i;
      var n;
      if (r && e.preventDefault(), "Escape" === i) return this._clearActiveMenu(), void (null == (n = this._sourceMenuButtonNode) || n.focus());
      var o = null == (s = this._sourceListNode) ? void 0 : s.getElementsByTagName("li");
      return o && 0 !== o.length && r ? ("source" !== this.activeMenu && (this.activeMenu = "source"), void this.handleItemNavigation(i, o, this._sourceListNode.parentElement)) : void 0;
    }
  }, {
    key: "_focus",
    value: function _focus(e) {
      this.focus(), e && (this.activeMenu = e);
    }
  }, {
    key: "_formSubmit",
    value: function _formSubmit(e) {
      e.preventDefault(), -1 === this._activeMenuItemIndex && this.search();
    }
  }, {
    key: "_getSourceName",
    value: function _getSourceName(e) {
      var t = this.messages,
          s = this.viewModel,
          i = s.allSources,
          r = i.getItemAt(e);
      return e === h.ALL_INDEX ? t.all : r && r.name || t.untitledSource;
    }
  }, {
    key: "_splitResult",
    value: function _splitResult(e, t) {
      var s = i(t);
      return e.replace(new RegExp("(^|)(".concat(s, ")(|$)"), "ig"), "$1|$2|$3").split("|");
    }
  }, {
    key: "_renderSearchResultsContent",
    value: function _renderSearchResultsContent() {
      return this._searchResultRenderer.showMoreResultsOpen = !1, this._searchResultRenderer.viewModel = this.viewModel, this._searchResultRenderer;
    }
  }]);

  return b;
}(c);

e([u()], b.prototype, "_activeMenuItemIndex", void 0), e([u()], b.prototype, "displayedSearchTerm", null), e([u({
  readOnly: !0
})], b.prototype, "inputId", null), e([u({
  readOnly: !0
})], b.prototype, "suggestionsMenuId", null), e([u({
  readOnly: !0
})], b.prototype, "sourceMenuId", null), e([u({
  readOnly: !0
})], b.prototype, "sourceMenuButtonId", null), e([u()], b.prototype, "activeMenu", void 0), e([a("viewModel.activeSource")], b.prototype, "activeSource", void 0), e([a("viewModel.activeSourceIndex")], b.prototype, "activeSourceIndex", void 0), e([a("viewModel.allPlaceholder")], b.prototype, "allPlaceholder", void 0), e([a("viewModel.allSources")], b.prototype, "allSources", void 0), e([a("viewModel.autoNavigate")], b.prototype, "autoNavigate", void 0), e([a("viewModel.autoSelect")], b.prototype, "autoSelect", void 0), e([a("viewModel.defaultSources")], b.prototype, "defaultSources", void 0), e([u()], b.prototype, "disabled", void 0), e([a("viewModel.goToOverride")], b.prototype, "goToOverride", void 0), e([u()], b.prototype, "iconClass", void 0), e([a("viewModel.includeDefaultSources")], b.prototype, "includeDefaultSources", void 0), e([u({
  aliasOf: {
    source: "messages.widgetLabel",
    overridable: !0
  }
})], b.prototype, "label", void 0), e([a("viewModel.locationEnabled")], b.prototype, "locationEnabled", void 0), e([a("viewModel.maxResults")], b.prototype, "maxResults", void 0), e([a("viewModel.maxSuggestions")], b.prototype, "maxSuggestions", void 0), e([u(), m("esri/widgets/Search/t9n/Search")], b.prototype, "messages", void 0), e([u(), m("esri/t9n/common")], b.prototype, "messagesCommon", void 0), e([a("viewModel.minSuggestCharacters")], b.prototype, "minSuggestCharacters", void 0), e([a("viewModel.popupEnabled")], b.prototype, "popupEnabled", void 0), e([a("viewModel.popupTemplate")], b.prototype, "popupTemplate", void 0), e([a("viewModel.portal")], b.prototype, "portal", void 0), e([a("viewModel.resultGraphic")], b.prototype, "resultGraphic", void 0), e([a("viewModel.resultGraphicEnabled")], b.prototype, "resultGraphicEnabled", void 0), e([a("viewModel.results")], b.prototype, "results", void 0), e([a("viewModel.searchAllEnabled")], b.prototype, "searchAllEnabled", void 0), e([a("viewModel.searchTerm")], b.prototype, "searchTerm", void 0), e([a("viewModel.selectedResult")], b.prototype, "selectedResult", void 0), e([a("viewModel.sources")], b.prototype, "sources", void 0), e([a("viewModel.suggestions")], b.prototype, "suggestions", void 0), e([a("viewModel.suggestionsEnabled")], b.prototype, "suggestionsEnabled", void 0), e([a("viewModel.view")], b.prototype, "view", void 0), e([v(["search-complete", "search-clear", "search-start", "select-result", "suggest-start", "suggest-complete"]), u({
  type: h
})], b.prototype, "viewModel", void 0), e([a("viewModel.clear")], b.prototype, "clear", null), b = e([l("esri.widgets.Search")], b);
var y = b;
export { y as default };